import { useTranslation } from 'react-i18next'

import { useMe } from '@hooks/user/me.hook'
import { useSignOut } from '@hooks/auth/sign-out.hook'
import { useDeleteUser } from '@hooks/user/delete-user.hook'

import { PopUpDelete } from '@components/PopUpDelete'

import { useToggle } from '@utils/hooks'

import {
  Container,
  SectionsContainer,
  Section,
  SectionTitle,
  SectionContent,
  ItemWrapper,
  ItemContainer,
  ItemText,
  Divider,
  DeleteButton,
} from './ProfileInfos.styled'

export const ProfileInfos = (): JSX.Element => {
  const { t } = useTranslation()

  const { getMe } = useMe()
  const { signOut } = useSignOut()
  const { deleteUser } = useDeleteUser({
    onCompleted: () => signOut(),
  })

  const [isDeletingAccount, toggleDeleting] = useToggle(false)

  const user = getMe()

  const onDeleteUser = () => {
    deleteUser()
    toggleDeleting()
  }

  return (
    <>
      <Container>
        <SectionsContainer>
          <Section>
            <SectionTitle>{t('modules_project_components_ProfileInfos_title')}</SectionTitle>
            <SectionContent>
              <ItemWrapper>
                <ItemContainer>
                  <ItemText>
                    {t('modules_project_components_ProfileInfos_section_personal_informations_lastname')}
                  </ItemText>
                  <ItemText style={{ flex: 'none', color: '#6b7280' }}>{user.lastName}</ItemText>
                </ItemContainer>
                <Divider />
                <ItemContainer>
                  <ItemText>
                    {t('modules_project_components_ProfileInfos_section_personal_informations_firstname')}
                  </ItemText>
                  <ItemText style={{ flex: 'none', color: '#6b7280' }}>{user.firstName}</ItemText>
                </ItemContainer>
                <Divider />
                <ItemContainer>
                  <ItemText>
                    {t('modules_project_components_ProfileInfos_section_personal_informations_email')}
                  </ItemText>
                  <ItemText style={{ flex: 'none', color: '#6b7280' }}>{user.email}</ItemText>
                </ItemContainer>
              </ItemWrapper>
            </SectionContent>
          </Section>
        </SectionsContainer>

        <DeleteButton
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()

            toggleDeleting()
          }}
        >
          {t('modules_project_components_ProfileInfos_delete_account_title')}
        </DeleteButton>

        {isDeletingAccount && (
          <PopUpDelete
            title={t('modules_project_components_ProfileInfos_delete_account_title')}
            description={t('modules_project_components_ProfileInfos_delete_account_description')}
            onSubmit={onDeleteUser}
            onClose={toggleDeleting}
          />
        )}
      </Container>
    </>
  )
}
